export default __webpack_public_path__ + "static/audio-cardio-1-243deed805dada8741cf9efafcb7a96f.webp";